import React, { useState, useEffect, useReducer } from "react";

import { useHistory } from "react-router-dom";

// components imports
import ChangePasswordForm from "../../components/common/ChangePasswordForm";

// Scss imports
import css from "./ChangePassword.module.scss";

// redux
import { useSelector, useDispatch } from "react-redux";
import { resetPassword } from "../../redux/actions/loginAction";

interface ChangePasswordProps {}

const ChangePassword: React.FC<ChangePasswordProps> = ({}) => {
  const dispatch = useDispatch();

  // Setting state for disabled button
  const [disabledButton, setDisabledButton] = useState(true);

  const resetPasswordMessage = useSelector(
    (state: any) => state.login.resetPasswordMessage
  );

  // Setting up state to hold informations about is state valid or no
  const [validPassword, setValidPassword] = useState(false);
  const [id, setId] = useState("");

  // Setting up variables
  let history = useHistory();

  // Setting up state to store input values
  const [userInput, setUserInput] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      password: "",
      repeatedPassword: ""
    }
  );

  const [form, setForm] = useState({
    password: userInput.password,
    passwordConfirm: userInput.repeatedPassword
  });

  // Setting up error text state
  const [errorText, setErrorText] = useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      password: "",
      repeatedPassword: ""
    }
  );

  useEffect(() => {
    setId(window.location.pathname.split("/")[2]);
  }, []);

  // Using use effect hook to watch change of inputs and when we will input pass and input email make button enabled
  useEffect(() => {
    // Set button status to enabled when all fields are valid
    if (
      userInput.password.match(
        "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
      ) != null &&
      userInput.repeatedPassword === userInput.password
    ) {
      setDisabledButton(false);
    }

    if (userInput.repeatedPassword === userInput.password) {
      setErrorText({
        repeatedPassword: ""
      });
    }

    setForm({
      password: userInput.password,
      passwordConfirm: userInput.repeatedPassword
    });
  }, [userInput.email, userInput.password, userInput.repeatedPassword]);

  // Login button handler
  const onClickButtonHandler = (e: any) => {
    dispatch(resetPassword(form, id, history));
  };

  // On input change set input name and value to text that user added
  const handleChange = (e: any, userInputType) => {
    const name = e.target.name;
    const newValue = e.target.value;
    setUserInput({ [name]: newValue });

    if (e.target.name === "repeatedPassword") {
      if (
        userInput.password.match(
          "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
        ) == null
      ) {
        setErrorText({
          repeatedPassword: "Прво унесите вашу шифру"
        });
      } else if (userInput.repeatedPassword !== userInput.password) {
        setErrorText({
          repeatedPassword: "Ваше шифре се не подударају"
        });
        setDisabledButton(true);
      }
    }
  };

  // Set error on input
  const onInputHandler = (e, errorType, error, pattern) => {
    const newValue = e.target.value;
    // Validation with pattern
    if (newValue.match(pattern) == null) {
      setErrorText({
        [errorType]: error
      });
      setDisabledButton(true);
    }
    if (newValue.match(pattern) != null) {
      setErrorText({
        [errorType]: ""
      });
    }
  };

  return (
    <div className={css.container}>
      <div className={css.changePasswordFormWrapper}>
        <h1>Промени шифру</h1>
        <ChangePasswordForm
          resetPasswordMessage={resetPasswordMessage}
          onClickButtonHandler={onClickButtonHandler}
          handleChange={handleChange}
          disabledButton={disabledButton}
          password={userInput.password}
          repeatedPassword={userInput.repeatedPassword}
          errorPasswordText={errorText.password}
          errorRepeatedPasswordText={errorText.repeatedPassword}
          onInputPassword={(e) =>
            onInputHandler(
              e,
              "password",
              "Шифра треба да има најмање осам карактера, барем једно велико слово, барем једино мало слово и барем један број",
              "^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$"
            )
          }
        />
      </div>
    </div>
  );
};

export default ChangePassword;
